// dependencies
// utils
import loMerge from "lodash.merge";
import { matchRoutes } from "react-router-dom";

// history
import { router } from "../app/router";

import ParseQueryString from "../utils/ParseQueryString";
import SerializeObject from "../utils/SerializeObject";

// constants
import RouterTags from "../constants/RouterTags";

export function GoBack() {
	return () => {
		router.navigate(-1);
	};
}

export function Replace(url) {
	return () => {
		const matches = matchRoutes(router.routes, window.location);
		const routeMatch = matches[matches.length - 1];

		if (routeMatch) {
			router.navigate(url, { replace: true });
			return true;
		}

		document.location.href = url;
		return false;
	};
}

export function HardPageLoad(url) {
	return () => {
		/*
            always does a hard page load
        */

		document.location.href = url;
		return false;
	};
}

export function ChangePage(url) {
	return () => {
		/*
            If we can't find a matching route, we do a hard page load.
        */

		const matches = matchRoutes(router.routes, url);
		const routeMatch = matches[matches.length - 1];

		const isBaseRoute = routeMatch?.route?.path === "*";
		const routeTags = routeMatch?.route?.handle?.tags ?? [];

		if (routeTags.includes(RouterTags.USES_TEMPLATE)) {
			document.location.href = url;
			return false;
		}

		if (isBaseRoute) {
			document.location.href = url;
			return false;
		}

		if (routeMatch) {
			router.navigate(url);
			return true;
		}

		document.location.href = url;
		return false;
	};
}

/**
 * Opens a url in a new tab. Since the tab is new, there is no reason to try
 * and find a route.
 */
export const openExternalPage = (url) => () => {
	const win = window.open(url, "_blank");
	win.focus();
};

export function ChangeQueryParameters(params = {}) {
	return () => {
		const currentURL = window.location.pathname;
		const queryString = SerializeObject(params);

		const nextURL = `${currentURL}?${queryString}`;

		router.navigate(nextURL, { replace: true });
	};
}

export function MergeQueryParameters(params = {}) {
	return () => {
		const currentURL = window.location.pathname;

		const currentParams = ParseQueryString(window.location.search);
		const mergedParams = loMerge(currentParams, params);
		const queryString = SerializeObject(mergedParams);

		const nextURL = `${currentURL}?${queryString}`;
		router.navigate(nextURL);
	};
}

/**
 * Removes the specified query parameters from the current url.
 *
 * */
export function RemoveQueryParameters(paramKeys = []) {
	return () => {
		const currentURL = window.location.pathname;
		const params = ParseQueryString(window.location.search);

		paramKeys.forEach((x) => {
			delete params[x];
		});

		const queryString = SerializeObject(params);
		const nextURL = `${currentURL}?${queryString}`;

		router.navigate(nextURL);
	};
}

/*
 * Reloads the page
 */
export function RefreshPage() {
	return () => {
		window.location.reload(false);
	};
}
